module.exports = __webpack_public_path__ + "camscanner/img/zfb.b82dcb42.png";